import React, { useEffect, useState, useRef,Fragment } from 'react';
import { Typography, Paper } from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogTitle, DialogContent, DialogActions  } from '../Dialog/Dialog';
import { getAllDrivers } from "../../../store/actions/vehicleActionCreator";
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete
} from 'mui-rff';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { numberFormat,findArrayObject, amountFormatOnly,isEmpty, getDateInStringDDMMMYYYY,numberWithCommas,checkNumberOnly,replaceCommas,sortByDisplay, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { AddPersonIcon } from '../../../components/icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Form } from 'react-final-form';
import { logoutUser } from "../../../store/actions/authActionCreators";
import { withRouter, useHistory } from 'react-router-dom';
import useStyles from '../../pages/css/forms';
import DriverGaveAndGot from '../DriverDialogs/DriverGaveAndGot';
import AddDriver from '../AddDialogComponent/AddDialogComponent';
import {IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import AddVehicle from '../../pages/Vehicles/AddVehicle';
import { getVehicleListV2 } from '../../../store/actions/tripActionCreator';
import { defaultPageSize,defaultPageNo,defaultDebounceMs } from '../../../paginationVariables';
import { debounce } from 'lodash';
import { Waypoint } from "react-waypoint";
import { TruckIcon } from '../../../components/icons';
function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

const filter = createFilterOptions({
    limit:30
  });

const JourneyVehicleSelect = ({ 
  props,trip,user,
  selectedVehicle,
  dispatchGetVehicleListAction, 
  defaultName,journey,selectedTrip,updateJourney, 
  dispatchGetAllDrivers, 
  onConfirm, onOpen, onClose, onSave, vehicle, dispatchAddNewDriver, type, 
  fromSingleTruck 
}) => {
    const classes = useStyles();
    const [dialogopen, setDialogOpen] = React.useState(onOpen);
    let submit;
    const [open, setOpen] = React.useState(false);
    const [dataFlag, setDataFlag] = useState(false);
    let vehicleVal = selectedVehicle?selectedVehicle:null
    const [vehicleValue, setVehicleValue] = React.useState({
      ...vehicleVal,
      id:vehicleVal&&vehicleVal.vehicleId?vehicleVal.vehicleId:null
    });
    const [vehicleInputValue, setVehicleInputValue] = React.useState("");
    const [vehicleListOpen, setvehicleListOpen] = React.useState(false);
    const [vehicleListOptions, setVehicleListOptions] = React.useState([]);
    const vehicleLoading = vehicleListOpen && trip && trip.createTripVehicles && trip.createTripVehicles.trucks && trip.createTripVehicles.trucks.length === 0;
    const [addVehicleOpen, toggleAddVehicleOpen] = React.useState(false);
    const [vehicleDialogValue, setVehicleDialogValue] = React.useState({
      ...vehicleVal,
      id:vehicleVal&&vehicleVal.vehicleId?vehicleVal.vehicleId:null
    });
    const [currentPageNoVehicle,setCurrentPageNoVehicle]  = useState(1);
    const [currentPageSizeVehicle,setCurrentPageSizeVehicle]  = useState(10);
    const fetchVehicles = (search,pagination)=>{
      let req = {
        pageSize:defaultPageSize,
        pageNo:defaultPageNo,
      }
      if(pagination){
        req.pageNo = currentPageNoVehicle+1;
        req.merge = true;
      }
      if(search){
        req.search=search;
      }
      dispatchGetVehicleListAction(req, () => { }, () => { })
    }
    const onSearchBlurVehicles = debounce(query => {
      setCurrentPageNoVehicle(defaultPageNo)
      fetchVehicles(query,false)
    }, user && user.configs && user.configs.dwebSearchBebounceMs?parseInt(user.configs.dwebSearchBebounceMs):defaultDebounceMs);
    const handleAddVehicleClose = () => {
      setVehicleDialogValue({
        vehicleNumber: '',
      });
      toggleAddVehicleOpen(false);
    };
    const handleVehicleSave = (status, response) => {
      toggleAddVehicleOpen(false);
      setVehicleValue(response && response.id ? response : null);
    }
    useEffect(() => {
      let defaultRequest = {
        pageSize:defaultPageSize,
        pageNo:defaultPageNo
      }
        if (vehicleListOpen) {
          dispatchGetVehicleListAction(defaultRequest, () => { }, () => { })
        }
    }, [vehicleListOpen]);

    const validate = values => {

        const errors = {};
        if ((!values.vehicle|| !values.vehicle.id)) {
            errors.vehicle = 'Please Select a Vehicle';
        }
        if (values && values.vehicle && values.vehicle.id) {
          setDataFlag(true);
        } else {
          setDataFlag(false);
        }
        return errors;
    };

    const handleClose = (status) => {
        onClose(false);
    };

    const onSubmit = values => {
        setDialogOpen(false);
        if (vehicleValue && vehicleValue.id) {
            onConfirm(vehicleValue);
        }
    }
    const vehicleDetails = [
        {
            size: 12,
            visible: false,
            field: (<>
              <div className={classes.titleV1}>Truck Registration Number*</div>
              <Autocomplete
                  classes={{
                    listbox: classes.listBoxAutoCompelete,
                    option: classes.listBoxOption
                  }
                  }
                  className={classes.mtV1}
                  id="select-vehicle-list"
                  open={vehicleListOpen}
                  onOpen={() => {
                    setvehicleListOpen(true)
                  }}
                  onClose={() => {
                   setvehicleListOpen(false)

                  }}
                  onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                      // timeout to avoid instant validation of the dialog's form.
                      setVehicleValue(null);
                      toggleAddVehicleOpen(true);
                      setVehicleDialogValue({
                        vehicleNumber: newValue.toUpperCase()
                      });
                    } else if (newValue && newValue.inputValue) {
                      setVehicleValue(null);
                      toggleAddVehicleOpen(true);
                      setVehicleDialogValue({
                        vehicleNumber: newValue.inputValue.toUpperCase()
                      });
                    } else if (newValue && newValue.inputValue === '') {
                      setVehicleValue(null);
                      toggleAddVehicleOpen(true);
                      setVehicleDialogValue({
                        vehicleNumber: ''
                      });
                    } else {
                      // if (newValue && newValue.status && newValue.status === 'On Trip') {
                      //   setVehicleValue(null);
                      //   newValue.type = 'FV'
                      //   setCompleteTripValue(newValue);
                      //   setCompleteTripOpen(true);
                      // } else {
                      setVehicleValue(newValue && newValue.id ? newValue : null);
                      // }
                    }
                  }}
                  name="vehicle"
                  size="small"
                  /*getOptionSelected={(option, value) =>{
                    return option.id === value.id && value.status != 'ONTRIP'
                  }}*/
                  required={true}
                  value={vehicleValue}
                  //groupBy={(option) => option.truckMapper}
                  autoHighlight
                  //freeSolo
                  options={trip && trip.createTripVehicles && trip.createTripVehicles.trucks ?trip.createTripVehicles.trucks : []}
                  selectOnFocus
                  clearOnBlur
                  handleHomeEndKeys
                  filterSelectedOptions
                  getOptionValue={option => option.id}
                  getOptionLabel={(option) => {
                    // e.g value selected with enter, right from the input
                    if (typeof option === 'string') {
                      return '';
                    }
                    if (option.inputValue || !option.id) {
                      return '';
                    }
                    return option.vehicleNumber
                  }}
                  disableCloseOnSelect={false}
                  filterOptions={(options, params) => {
                    //const filtered = filter(options, params);
                    let filtered =[]
                    options.forEach((item,index)=>{
                      filtered.push({
                        ...item,
                        index:index
                      })
                    });
                    filtered.unshift({
                      inputValue: params.inputValue,
                      vehicleNumber: params.inputValue && params.inputValue.length > 1 ? `Add Details for '${params.inputValue.toUpperCase()}'` : `Add New Vehicle`,
                    });
                    return filtered;
                  }}
                  renderOption={(option, { selected, inputValue }) => {

                    const vehicleNumberValue = option && option.vehicleNumber ? option.vehicleNumber.split(/'/) : option.vehicleNumber;

                    if (vehicleNumberValue && vehicleNumberValue.length > 0 && !vehicleNumberValue.includes("Add New Vehicle")) {
                      vehicleNumberValue.pop();
                    }

                    if (option && option.id) {
                      let list = trip && trip.createTripVehicles && trip.createTripVehicles.trucks?trip.createTripVehicles.trucks:[]
                      if (option.index == list.length-1) {
                        return(<Fragment>
                                <Waypoint
                                  onEnter={() => {
                                    if(trip && trip.createTripVehicles && trip.createTripVehicles.maxPage && trip.createTripVehicles.maxPage != currentPageNoVehicle){
                                      setCurrentPageNoVehicle(currentPageNoVehicle+1)
                                      fetchVehicles(option.inputValue,true)
                                    }
                                  }}
                                />
                                 <div className={classes.vehicleListItem}>
                                    <div className={classes.divVehicleListing}>
                                      <span>{option.vehicleNumberPrefix}
                                        <span className={classes.vehicleNumberSuffix}>{option.vehicleNumberSuffix}</span>
                                        {option.lastLocation && <>
                                          <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                          {option.lastLocation}
                                        </>}
                                      </span>
                                    </div>
                                    <div className={classes.vehicleListItemFlex}>
                                      <div className={classes.ownershipType}>
                                        <span className={option.ownershipType && option.ownershipType == 'HIRED' ? classes.hired : classes.own}>{option.ownershipType && option.ownershipType == 'HIRED' ? 'Market' : 'Own'}</span>
                                      </div>
                                      <div className={classes.vehicleStatus}><span>{option.status}</span><FiberManualRecordIcon className={option.status && option.status == 'ONTRIP' ? classes.onTripBullet : classes.avilableBullet}></FiberManualRecordIcon></div>
                                    </div>
                                  </div>
                              </Fragment>);
                      }else{
                          return (
                            <div className={classes.vehicleListItem}>
                              <div className={classes.divVehicleListing}>
                                <span>{option.vehicleNumberPrefix}
                                  <span className={classes.vehicleNumberSuffix}>{option.vehicleNumberSuffix}</span>
                                  {option.lastLocation && <>
                                    <FiberManualRecordIcon className={classes.titleBullet}></FiberManualRecordIcon>
                                    {option.lastLocation}
                                  </>}
                                </span>
                              </div>
                              <div className={classes.vehicleListItemFlex}>
                                <div className={classes.ownershipType}>
                                  <span className={option.ownershipType && option.ownershipType == 'HIRED' ? classes.hired : classes.own}>{option.ownershipType && option.ownershipType == 'HIRED' ? 'Market' : 'Own'}</span>
                                </div>
                                <div className={classes.vehicleStatus}><span>{option.status}</span><FiberManualRecordIcon className={option.status && option.status == 'ONTRIP' ? classes.onTripBullet : classes.avilableBullet}></FiberManualRecordIcon></div>
                              </div>
                            </div>
                          );
                      }
                    } else {
                      return (
                        <div className={classes.partyAddListItem}>
                          <TruckIcon className={classes.truckIcon} />
                          {vehicleNumberValue && vehicleNumberValue.map((value, index) => (
                            <span style={{ color: index == 0 ? '#0033cc' : 'black', marginLeft: 10 }}>{value}</span>
                          ))
                          }
                          <ChevronRightIcon className={classes.cherveRightIcon} />
                        </div>
                      );
                    }

                  }}
                  inputValue={vehicleInputValue}
                  onInputChange={(e, val) => {
                    setVehicleInputValue(val.toUpperCase())
                    onSearchBlurVehicles(val,false)
                  }}
                  textFieldProps={
                    {
                      placeholder: "Eg: KA 02 Q 1234",
                      variant: "outlined",
                      margin: 'none',
                    }
                  }
                  multiple={false}
                />
            </>
            ),
          }
    ]
    return (
        <>
            <div>
                <Dialog fullWidth={true}
                    maxWidth='xs'
                    onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogopen}>
                    <DialogTitle className={classes.dialogTitleV2}>
                        <div className={classes.fw300}>Select Truck</div>
                        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Form
                            onSubmit={onSubmit}
                            initialValues={{vehicle:vehicleValue}}
                            validate={validate}
                            render={({ handleSubmit, form, submitting, pristine, values }) =>{ 
                              submit = handleSubmit
                              return (
                                <form onSubmit={handleSubmit} noValidate>
                                    {vehicleDetails.map((item, idx) => (
                                        item.field
                                    ))}
                                    {/* <div>
                                        <Button className={classes.continue} variant="outlined" type="submit">
                                            Continue
                                        </Button>
                                    </div> */}
                                </form>
                            )}}
                        />
                    </DialogContent>
                    <DialogActions>
                    <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
                      Close
                    </Button>
                    <Button className={!dataFlag ? classes.disableCta : classes.saveCta} type="submit" variant="contained"
                      onClick={event => {
                        submit(event)
                      }}
                      disabled={!dataFlag}
                    >
                      Save Truck
                    </Button>
                  </DialogActions>
                </Dialog>
            </div>
            {addVehicleOpen && <AddVehicle open={addVehicleOpen} defaultVechicleNumber={vehicleDialogValue.vehicleNumber} onClose={handleAddVehicleClose} onSave={handleVehicleSave} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchLogoutAction: () => dispatch(logoutUser()),
    dispatchGetAllDrivers: (onSuccess, onFailure) => dispatch(getAllDrivers(null, onSuccess, onFailure)),
    dispatchGetVehicleListAction: (data, onSuccess, onFailure) => dispatch(getVehicleListV2(data, onSuccess, onFailure)),
});
const JourneyVehicleSelectWithRouter = withRouter(JourneyVehicleSelect);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(JourneyVehicleSelectWithRouter);